import * as marietta from '../..';
import { SVGSprite } from '../flash/display';
import { Stage } from '../model';
import ItemController from './ItemController';

/**
 *階段itemcontrollerクラス
 */
class ItemControllerStair extends ItemController {
  /**
   *コンストラクタ
   * @param _target
   */
  constructor(_target: marietta.webcad.item.MonicaObject) {
    super(_target);
    // 特定アイテムは、リサイズ不可
    if (!this.target.isCapableOfResize()) {
      this.dragObj_T.hide();
      this.dragObj_TL.hide();
      this.dragObj_TR.hide();
      this.dragObj_L.hide();
      this.dragObj_R.hide();
      this.dragObj_B.hide();
      this.dragObj_BL.hide();
      this.dragObj_BR.hide();
    }
    if (this.target.itemInfo.lock) {
      this.hideToolTips();
    } else {
      this.showToolTips();
    }
  }

  /**
   * コントロールピッカーが移動された
  */
  moveControlPicker(e: MouseEvent, target: marietta.webcad.control.parts.ControlPicker) {
    // ロックされている場合は、行わない
    if (!this.target.isCapableOfResize()) return;
    // 開始時のアイテム場所保持
    if (this.startPoint === undefined) {
      // 階段を一旦消す
      this.target.spt.visible = false;
      this.target.spt.update();

      if (this.emptySpt === undefined) {
        /*
        本来はtarget.sptのmouseX/mouseYで取得できるが、
        拡縮するとアイテムの位置が変わるため、正しいドラッグ位置が取れなくなる。
        そのためタグを持たないemptySptを別途作って、mouseX/mouseYの値を
        取得している。
        */
        this.emptySpt = new SVGSprite(null, true);
        this.emptySpt.setEmptyParam((this.target as marietta.webcad.item.Stair).patternSpt);
        (this.target as marietta.webcad.item.Stair).patternSpt.parent.addChild(this.emptySpt);
      }

      this.startPoint = new marietta.core.Point(
        this.emptySpt.mouseX * (this.target as marietta.webcad.item.Stair).patternSpt.scaleX,
        this.emptySpt.mouseY * (this.target as marietta.webcad.item.Stair).patternSpt.scaleY,
      );

      // added k.kubonaka (WEBCAD-1020対応)
      this.resizeToTarget();
    }

    // var newPoint:marietta.core.Point = marietta.webcad.util.WebCADUtil.convertToLocalPoint(e);
    const newPoint: marietta.core.Point = new marietta.core.Point(
      this.emptySpt.mouseX * (this.target as marietta.webcad.item.Stair).patternSpt.scaleX,
      this.emptySpt.mouseY * (this.target as marietta.webcad.item.Stair).patternSpt.scaleY,
    );

    // Debugger.log(this.target.spt.rotation);

    // アイテムの角度分、座標変換を行う
    let r: number = (-(this.target.spt.rotation % 360) / 180) * Math.PI;
    if (Number.isNaN(r)) r = 0;
    const xx: number = newPoint.x * Math.cos(r) - newPoint.y * Math.sin(r);
    const yy: number = newPoint.x * Math.sin(r) + newPoint.y * Math.cos(r);

    newPoint.x = xx;
    newPoint.y = yy;
    // ｘ’＝ｘcosθ-ysinθ
    // ｙ’＝ｘsinθ+ycosθ

    // Debugger.log("onMoveControlPicker " + newPoint.x + " " + newPoint.y);
    const snapUnit = marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnitPix;

    // ドラッグ範囲
    // 他のピッカーの整理
    switch (target) {
      case this.dragObj_TL:
        newPoint.x = this.dragObj_R.x - Math.round((this.dragObj_R.x - newPoint.x) / snapUnit) * snapUnit;
        newPoint.y = this.dragObj_B.y - Math.round((this.dragObj_B.y - newPoint.y) / snapUnit) * snapUnit;
        if (this.dragObj_R.x - snapUnit < newPoint.x) newPoint.x = this.dragObj_R.x - snapUnit;
        if (this.dragObj_B.y - snapUnit < newPoint.y) newPoint.y = this.dragObj_B.y - snapUnit;
        target.move(newPoint.x, newPoint.y);
        break;
      case this.dragObj_T:
        newPoint.y = this.dragObj_B.y - Math.round((this.dragObj_B.y - newPoint.y) / snapUnit) * snapUnit;
        if (this.dragObj_B.y - snapUnit < newPoint.y) newPoint.y = this.dragObj_B.y - snapUnit;
        target.moveY(newPoint.y/* - this.target.itemInfo.y */);
        break;
      case this.dragObj_B:
        newPoint.y = this.dragObj_T.y + Math.round((newPoint.y - this.dragObj_T.y) / snapUnit) * snapUnit;
        if (newPoint.y < this.dragObj_T.y + snapUnit) newPoint.y = this.dragObj_T.y + snapUnit;
        target.moveY(newPoint.y/* - this.target.itemInfo.y */);
        break;
      case this.dragObj_BL:
        newPoint.x = this.dragObj_R.x - Math.round((this.dragObj_R.x - newPoint.x) / snapUnit) * snapUnit;
        newPoint.y = this.dragObj_T.y + Math.round((newPoint.y - this.dragObj_T.y) / snapUnit) * snapUnit;
        if (this.dragObj_R.x - snapUnit < newPoint.x) newPoint.x = this.dragObj_R.x - snapUnit;
        if (newPoint.y < this.dragObj_T.y + snapUnit) newPoint.y = this.dragObj_T.y + snapUnit;
        target.move(newPoint.x, newPoint.y);
        break;
      case this.dragObj_L:
        newPoint.x = this.dragObj_R.x - Math.round((this.dragObj_R.x - newPoint.x) / snapUnit) * snapUnit;
        if (this.dragObj_R.x - snapUnit < newPoint.x) newPoint.x = this.dragObj_R.x - snapUnit;
        target.moveX(newPoint.x/* - this.target.itemInfo.x */);
        break;
      case this.dragObj_TR:
        // k.kubonaka WEBCAD-1080対応
        newPoint.x = this.dragObj_L.x + Math.round((newPoint.x - this.dragObj_L.x) / snapUnit) * snapUnit;
        newPoint.y = this.dragObj_B.y - Math.round((this.dragObj_B.y - newPoint.y) / snapUnit) * snapUnit;
        if (newPoint.x < this.dragObj_L.x + snapUnit) newPoint.x = this.dragObj_L.x + snapUnit;
        if (this.dragObj_B.y - snapUnit < newPoint.y) newPoint.y = this.dragObj_B.y - snapUnit;
        target.move(newPoint.x, newPoint.y);
        break;
      case this.dragObj_R:
        // k.kubonaka WEBCAD-1080対応
        newPoint.x = this.dragObj_L.x + Math.round((newPoint.x - this.dragObj_L.x) / snapUnit) * snapUnit;
        if (newPoint.x < this.dragObj_L.x + snapUnit) newPoint.x = this.dragObj_L.x + snapUnit;
        target.moveX(newPoint.x/* - this.target.itemInfo.x */);
        break;
      case this.dragObj_BR:

        // Debugger.text(0, newPoint.x + " " + newPoint.y);

        // k.kubonaka WEBCAD-916対応
        newPoint.x = this.dragObj_L.x + Math.round((newPoint.x - this.dragObj_L.x) / snapUnit) * snapUnit;
        newPoint.y = this.dragObj_T.y + Math.round((newPoint.y - this.dragObj_T.y) / snapUnit) * snapUnit;
        if (newPoint.x < this.dragObj_L.x + snapUnit) newPoint.x = this.dragObj_L.x + snapUnit;
        if (newPoint.y < this.dragObj_T.y + snapUnit) newPoint.y = this.dragObj_T.y + snapUnit;
        target.move(newPoint.x, newPoint.y);

        // Debugger.text(1, newPoint.x + " " + newPoint.y);
        break;
      default:
        break;
    }

    // 他のピッカーの整理
    switch (target) {
      case this.dragObj_T:
        this.dragObj_TR.moveY(target.y);
        this.dragObj_TL.moveY(target.y);
        break;
      case this.dragObj_B:
        this.dragObj_BR.moveY(target.y);
        this.dragObj_BL.moveY(target.y);
        break;
      case this.dragObj_L:
        this.dragObj_TL.moveX(target.x);
        this.dragObj_BL.moveX(target.x);
        break;
      case this.dragObj_R:
        this.dragObj_TR.moveX(target.x);
        this.dragObj_BR.moveX(target.x);
        break;
      case this.dragObj_TL:
        this.dragObj_L.moveX(target.x);
        this.dragObj_BL.moveX(target.x);
        this.dragObj_TR.moveY(target.y);
        this.dragObj_T.moveY(target.y);
        break;
      case this.dragObj_TR:
        this.dragObj_R.moveX(target.x);
        this.dragObj_BR.moveX(target.x);
        this.dragObj_TL.moveY(target.y);
        this.dragObj_T.moveY(target.y);
        break;
      case this.dragObj_BL:
        this.dragObj_L.moveX(target.x);
        this.dragObj_TL.moveX(target.x);
        this.dragObj_BR.moveY(target.y);
        this.dragObj_B.moveY(target.y);
        break;
      case this.dragObj_BR:
        this.dragObj_R.moveX(target.x);
        this.dragObj_TR.moveX(target.x);
        this.dragObj_BL.moveY(target.y);
        this.dragObj_B.moveY(target.y);
        break;
      default:
        break;
    }
    this.rotator.move(this.dragObj_T.x - 6.5, this.dragObj_T.y - 25);

    // 中点の再配置
    switch (target) {
      case this.dragObj_T:
      case this.dragObj_B:
        this.dragObj_L.moveY(this.dragObj_B.y + (this.dragObj_T.y - this.dragObj_B.y) / 2);
        this.dragObj_R.moveY(this.dragObj_B.y + (this.dragObj_T.y - this.dragObj_B.y) / 2);
        break;
      case this.dragObj_L:
      case this.dragObj_R:
        this.dragObj_T.moveX(this.dragObj_L.x + (this.dragObj_R.x - this.dragObj_L.x) / 2);
        this.dragObj_B.moveX(this.dragObj_L.x + (this.dragObj_R.x - this.dragObj_L.x) / 2);
        break;
      default:
      case this.dragObj_TL:
      case this.dragObj_TR:
      case this.dragObj_BL:
      case this.dragObj_BR:
        this.dragObj_L.moveY(this.dragObj_B.y + (this.dragObj_T.y - this.dragObj_B.y) / 2);
        this.dragObj_R.moveY(this.dragObj_B.y + (this.dragObj_T.y - this.dragObj_B.y) / 2);
        this.dragObj_T.moveX(this.dragObj_L.x + (this.dragObj_R.x - this.dragObj_L.x) / 2);
        this.dragObj_B.moveX(this.dragObj_L.x + (this.dragObj_R.x - this.dragObj_L.x) / 2);
        break;
    }

    // 矩形のサイズ変更
    // eslint-disable-next-line object-curly-newline
    const rect = { x: this.dragObj_BL.x, y: this.dragObj_BL.y, width: (this.dragObj_BR.x - this.dragObj_BL.x), height: (this.dragObj_BR.y - this.dragObj_TR.y) };
    this.allBox.resize(rect);
    this.allBox.move(this.dragObj_TL.x + (this.dragObj_TR.x - this.dragObj_TL.x) / 2,
      this.dragObj_TL.y + (this.dragObj_BL.y - this.dragObj_TL.y) / 2);
  }

  previousSize;

  /**
   * ターゲットのリサイズ
   * @returns
   */
  resizeTarget() {
    if (this.previousSize) {
      if (this.previousSize.w === this.allBox.width && this.previousSize.h === this.allBox.height) return;
    }
    // サイズ変更
    const w: number = this.allBox.width;
    const h: number = this.allBox.height;
    this.target.changeSize(w, h, true);

    this.previousSize = { w, h };

    // 中心点を計算
    const rect = this.allBox.viewObj.getBoundingClientRect();
    const left: number = (rect.left) - Stage.offsetX;
    const top: number = (rect.top) - Stage.offsetY;

    // 位置調整
    // 一番ルートであるLayerGroupの倍率をで割る事で拡縮時でもずれないように
    // layerGroupが持つSpriteのscaleX/scaleyで取得可能
    const stage: SVGSprite = marietta.webcad.WebCADGlobal.layerGroup.spt;
    this.target.move((left + (rect.width / 2)) / stage.scaleX/* - 200 */, (top + (rect.height / 2)) / stage.scaleY /* - 50 */);
  }

  /**
   * ツールチップを非表示
   */
  hideToolTips() {
    this.rotator.hide();
  }

  /**
   * ツールチップを表示する
   */
  showToolTips() {
    this.rotator.show();
  }
}
export default ItemControllerStair;
